import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-pop-up.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-pop-up.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../constants/shared-constants";
import { AflaCommonService } from "../../afla-common.service";
let CommonPopUpComponent = class CommonPopUpComponent {
    activeModal;
    aflaCommonService;
    title = "";
    contentMessage = "";
    data;
    updateBtnPlaceholder = SharedConstants.YES_LABEL;
    cancelBtnPlaceholder = SharedConstants.NO_LABEL;
    branding;
    constructor(activeModal, aflaCommonService) {
        this.activeModal = activeModal;
        this.aflaCommonService = aflaCommonService;
        this.branding = aflaCommonService.branding;
    }
    onBtnOkClick() {
        this.activeModal.close(this.data);
    }
    onBtnCancel() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AflaCommonService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        contentMessage: [{ type: Input }],
        data: [{ type: Input }],
        updateBtnPlaceholder: [{ type: Input }],
        cancelBtnPlaceholder: [{ type: Input }]
    };
};
CommonPopUpComponent = __decorate([
    Component({
        selector: "lib-pop-up.component",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonPopUpComponent);
export { CommonPopUpComponent };
